const EXPIRE_MINUTE = 20;
const TEMPI_VP = "_tempi_vp";
const TEMPI_VS = "_tempi_vs";
const SMART_POPUP_IDS = "_tempi_smart_popup_ids";
const NEW_USER = "NEW";
const RETURNING = "RETURNING";
const UNIDENTIFIED = "unidentified";

export { EXPIRE_MINUTE, NEW_USER, RETURNING, SMART_POPUP_IDS, TEMPI_VP, TEMPI_VS, UNIDENTIFIED };
